module.exports = __webpack_public_path__ + "static/media/Eyes_1.12c93ec7.jpg";